<script lang="ts" setup>
import type { VChip } from 'vuetify/components'

const {
  color = 'primary',
  variant = 'tonal',
  density = 'default',
  size = 'small',
  bgColor,
  textColor,
} = defineProps<{
  color?: VChip['$props']['color']
  size?: VChip['$props']['size']
  density?: VChip['$props']['density']
  variant?: VChip['$props']['variant']
  label?: boolean
  truncated?: boolean
  bgColor?: string
  textColor?: string
}>()

const { getColorValue } = useColor()
const chipStyle = computed(() => {
  return bgColor ? { backgroundColor: getColorValue(bgColor) } : {}
})
</script>

<template>
  <v-chip
    :class="['skr-chip', { 'skr-chip--truncated': truncated }, `text-${textColor}`]"
    :color="color"
    :size="size"
    :density="density"
    :variant="variant"
    :label="label"
    :style="chipStyle"
  >
    <slot />
  </v-chip>
</template>

<style lang="scss">
.skr-chip--truncated {
  .v-chip__content {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
